import React from 'react';

import './Progressbar.scss';

const Progressbar = ({ value }) => (
  <>
    <div styleName="dashboard-progressbar">
      <span styleName="dashboard-progressbar__empty"></span>
      <span styleName="dashboard-progressbar__full" style={{ transform: `translateX(${value})` }}></span>
    </div>
  </>
);

export default Progressbar;
